import { createSelector } from "reselect";
import { RootState } from "../../state";
import { CategorizedCompanyValueFeature } from "../entities";

export const featuresSelector = createSelector(
  (state: RootState) => state.company_values.entities.company_value_features,
  (state: RootState) => state.company_values.features.list,
  (map, list) => {
    return list.map(id => map[id]!);
  }
);

export const categorizedFeaturesSelector = createSelector(
  (state: RootState) => featuresSelector(state),
  features => {
    return features.reduce(
      (acc, feat) => {
        let cat = acc.find(cat => cat.category === feat.feature_category);
        if (!cat) {
          cat = { category: feat.feature_category, features: [] };
          acc.push(cat);
        }
        cat.features.push(feat);
        return acc;
      },
      [] as CategorizedCompanyValueFeature[]
    );
  }
);

export const companiesSelector = createSelector(
  (state: RootState) => state.company_values.entities.companies,
  (state: RootState) => state.company_values.search.companies,
  (map, list) => {
    return list.map(id => map[id]!);
  }
);

export const currentCompanySelector = createSelector(
  (state: RootState) => state.company_values.entities.companies,
  (state: RootState) => state.company_values.common.currentWorkingCompanyId,
  (companies, companyId) => (companyId ? companies[companyId] : undefined)
);

export const selectCompanyValues = createSelector(
  (state: RootState, values: EntityId[]) => values.map(value => state.company_values.entities.company_values[value]!),
  values => values
);



// WEBPACK FOOTER //
// ./frontend/src/company_values/selectors/index.ts